import React from 'react'
import Image from 'next/image'
import tbankLogo from './tbank.png' 

export const Tbank = () => {
  return <Image width={24} height={24} src={tbankLogo} alt='Tbank' />
}
